/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from '../../../services'

 
export const getAllDevice = createAsyncThunk('device/getAllDevice', async (_, { rejectWithValue }) => {
    try { 
        const data = await api.device.getAllDevice()
        return Promise.resolve(data)
    } catch (error) {
        return rejectWithValue(error.message);
    }
})

export const getDeviceHistory = createAsyncThunk('device/getDeviceHistory', async (params, { rejectWithValue }) => {
    try { 
        const data = await api.device.getDeviceHistory(params)
        return Promise.resolve(data)
    } catch (error) {
        return rejectWithValue(error.message);
    }
})
